import { css } from 'styled-components';

export type TProps = {
  focused: boolean;
  error: boolean;
};

export const stripeInputStyles = css<TProps>`
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 5px;
  background: var(--color-form-field-bg, var(--color-surface-muted));
  box-shadow: none;
  outline: none;

  & > div {
    width: 100% !important;
    height: 100% !important;
  }

  &:hover {
    box-shadow: 0 0 0 1px var(--color-nav-active-bg);
  }

  ${({ focused }) =>
    focused &&
    css`
      box-shadow: 0 0 0 1px var(--color-nav-active-bg);
    `}

  ${({ error }) =>
    error &&
    css`
      box-shadow: 0 0 0 1px #ff2f2f;
    `}
`;
